<template>
  <v-footer dark padless>
    <v-card class="flex" flat tile>
      <v-card-text class="py-8 white--text text-center">
        © 2018-{{ new Date().getFullYear() }}, Raging Pixel Studios LLC. All
        rights reserved.
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
export default {
  name: "Footer",

  data: () => ({
    //
  })
};
</script>
